export const useIntercom = () => {
  const showIntercom = () => {
    window.Intercom('show')
  }

  const hideIntercom = () => {
    window.Intercom('hide')
  }

  return {
    showIntercom,
    hideIntercom,
  }
}
